// import React, { useState, useEffect } from "react";
// import API_BASE_URL from "../config";

// const BASE_URL = API_BASE_URL;

// const DriverVehicleTracking = () => {
//   const [vehicles, setVehicles] = useState([]);
//   const [tracking, setTracking] = useState(false);
//   const [selected, setSelected] = useState(null);
//   const [error, setError] = useState("");
//   const [lastUpdated, setLastUpdated] = useState(null);

//   const fetchLocations = async () => {
//     try {
//       const res = await fetch(`${BASE_URL}/vehicle/fetch-locations`);
//       const data = await res.json();
//       if (Array.isArray(data)) { setVehicles(data); setLastUpdated(new Date().toLocaleTimeString()); setError(""); }
//     } catch { setError("Unable to fetch vehicle locations. Check backend connection."); }
//   };

//   useEffect(() => {
//     let interval;
//     if (tracking) { fetchLocations(); interval = setInterval(fetchLocations, 5000); }
//     return () => clearInterval(interval);
//   }, [tracking]);

//   const selectedVehicle = selected !== null ? vehicles[selected] : null;

//   const S = {
//     page: { marginLeft: "270px", padding: "24px", fontFamily: "Arial, sans-serif", backgroundColor: "#fff", minHeight: "100vh" },
//     heading: { textAlign: "center", backgroundColor: "#000", color: "#fff", padding: "12px 24px", borderRadius: "8px", width: "fit-content", margin: "0 auto 24px", fontSize: "1.5rem", fontWeight: "bold", textTransform: "uppercase" },
//     card: { backgroundColor: "#fff", borderRadius: 8, padding: 24, boxShadow: "0 2px 8px rgba(0,0,0,0.1)", marginBottom: 20 },
//     controlRow: { display: "flex", gap: 12, alignItems: "center", marginBottom: 16, flexWrap: "wrap" },
//     startBtn: { background: tracking ? "#ccc" : "#27ae60", color: "#fff", border: "none", padding: "10px 24px", borderRadius: 6, cursor: tracking ? "not-allowed" : "pointer", fontWeight: "bold", fontSize: 13 },
//     stopBtn: { background: !tracking ? "#ccc" : "#e53935", color: "#fff", border: "none", padding: "10px 24px", borderRadius: 6, cursor: !tracking ? "not-allowed" : "pointer", fontWeight: "bold", fontSize: 13 },
//     statusDot: { width: 10, height: 10, borderRadius: "50%", background: tracking ? "#27ae60" : "#ccc", display: "inline-block", marginRight: 6 },
//     grid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 12 },
//     vehicleCard: (sel, moving) => ({ padding: "16px", borderRadius: 8, border: sel ? "2px solid #FFC107" : "2px solid transparent", background: sel ? "#fffbf0" : "#f9f9f9", cursor: "pointer", transition: "all 0.15s", position: "relative" }),
//     vehId: { fontWeight: "bold", fontSize: 14, marginBottom: 4 },
//     vehStatus: (m) => ({ fontSize: 11, fontWeight: "bold", color: m ? "#27ae60" : "#e53935", background: m ? "#e6f9ee" : "#fde8e8", padding: "2px 8px", borderRadius: 10, display: "inline-block" }),
//     detailBox: { background: "#f0f4f8", borderRadius: 8, padding: 20, marginTop: 16 },
//     detailGrid: { display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 },
//     detailCard: { background: "#fff", borderRadius: 6, padding: "12px 16px", textAlign: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.07)" },
//     detailVal: { fontSize: 18, fontWeight: "bold", color: "#111" },
//     detailLabel: { fontSize: 11, color: "#888", marginTop: 4 },
//   };

//   return (
//     <div style={S.page}>
//       <h2 className="sendo-heading">Vehicle Tracking</h2>
//       <style>{`@keyframes blink{0%,100%{opacity:1}50%{opacity:0.3}}`}</style>
//       <h2 style={S.heading}>Driver Vehicle Tracking</h2>
//       <div style={S.card}>
//         <div style={S.controlRow}>
//           <span style={S.statusDot}></span>
//           <span style={{ fontSize: 13, color: "#555", marginRight: 12 }}>
//             {tracking ? `Live · Updated ${lastUpdated || "..."}` : "Tracking inactive"}
//           </span>
//           <button style={S.startBtn} disabled={tracking} onClick={() => setTracking(true)}>📡 Start Tracking</button>
//           <button style={S.stopBtn} disabled={!tracking} onClick={() => setTracking(false)}>■ Stop</button>
//         </div>
//         {error && <div style={{ color: "#e53935", fontSize: 12, marginBottom: 12 }}>{error}</div>}
//         {vehicles.length > 0 ? (
//           <>
//             <div style={{ fontSize: 12, color: "#888", marginBottom: 12 }}>{vehicles.length} vehicle(s) tracked · Click a card to view details</div>
//             <div style={S.grid}>
//               {vehicles.map((v, i) => {
//                 const moving = Number(v.speed) > 0;
//                 return (
//                   <div key={i} style={S.vehicleCard(selected === i, moving)} onClick={() => setSelected(selected === i ? null : i)}>
//                     <div style={S.vehId}>{v.id || v.vehicleNumber || `Vehicle ${i+1}`}</div>
//                     <div style={{ fontSize: 12, color: "#666", margin: "4px 0" }}>{(v.lat || v.latitude)?.toFixed(4)}, {(v.lng || v.longitude)?.toFixed(4)}</div>
//                     <span style={S.vehStatus(moving)}>{moving ? `Moving · ${v.speed} km/h` : "Stopped"}</span>
//                   </div>
//                 );
//               })}
//             </div>
//             {selectedVehicle && (
//               <div style={S.detailBox}>
//                 <b>Vehicle {selectedVehicle.id || selectedVehicle.vehicleNumber || `#${selected+1}`} — Details</b>
//                 <div style={S.detailGrid}>
//                   <div style={S.detailCard}><div style={S.detailVal}>{(selectedVehicle.lat || selectedVehicle.latitude)?.toFixed(5)}</div><div style={S.detailLabel}>Latitude</div></div>
//                   <div style={S.detailCard}><div style={S.detailVal}>{(selectedVehicle.lng || selectedVehicle.longitude)?.toFixed(5)}</div><div style={S.detailLabel}>Longitude</div></div>
//                   <div style={S.detailCard}><div style={S.detailVal}>{selectedVehicle.speed ?? "0"} km/h</div><div style={S.detailLabel}>Speed</div></div>
//                 </div>
//               </div>
//             )}
//           </>
//         ) : (
//           <div style={{ textAlign: "center", padding: "32px", color: "#aaa" }}>
//             {tracking ? "Fetching vehicle locations..." : "Start tracking to see vehicle locations"}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default DriverVehicleTracking;
import React, { useState, useEffect } from "react";
import API_BASE_URL from "../config";

const BASE_URL = API_BASE_URL;

const DriverVehicleTracking = () => {
  const [vehicles, setVehicles] = useState([]);
  const [tracking, setTracking] = useState(false);
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState("");
  const [lastUpdated, setLastUpdated] = useState(null);

  const fetchLocations = async () => {
    try {
      const res = await fetch(`${BASE_URL}/vehicle/fetch-locations`);
      const data = await res.json();
      if (Array.isArray(data)) {
        setVehicles(data);
        setLastUpdated(new Date().toLocaleTimeString());
        setError("");
      }
    } catch {
      setError("Unable to fetch vehicle locations. Check backend connection.");
    }
  };

  useEffect(() => {
    let interval;
    if (tracking) {
      fetchLocations();
      interval = setInterval(fetchLocations, 5000);
    }
    return () => clearInterval(interval);
  }, [tracking]);

  const selectedVehicle = selected !== null ? vehicles[selected] : null;

  const s = {
    container: {
      fontFamily: "Arial, sans-serif",
      marginLeft: "278px",
      marginRight: "10px",
      backgroundColor: "#ffffff",
      color: "#000000",
      minHeight: "100vh",
    },
    pageHeader: {
      backgroundColor: "#FFC107",
      padding: "16px 24px",
      marginBottom: "0px",
    },
    pageHeaderText: {
      fontSize: "22px",
      fontWeight: "700",
      color: "#000000",
      letterSpacing: "1px",
      textTransform: "uppercase",
      margin: 0,
    },
    contentBody: {
      padding: "24px",
    },
    sectionTitle: {
      fontSize: "15px",
      fontWeight: "700",
      color: "#000000",
      marginBottom: "4px",
    },
    sectionDivider: {
      border: "none",
      borderTop: "2px solid #FFC107",
      marginBottom: "16px",
    },
    controlRow: {
      display: "flex",
      gap: "12px",
      alignItems: "center",
      flexWrap: "wrap",
      marginBottom: "16px",
    },
    pulseWrap: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      fontSize: "13px",
      fontWeight: "700",
      color: "#000000",
    },
    pulse: {
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      backgroundColor: tracking ? "#FFC107" : "#cccccc",
      display: "inline-block",
      animation: tracking ? "blink 1s infinite" : "none",
    },
    startBtn: {
      backgroundColor: tracking ? "#cccccc" : "#FFC107",
      color: "#000000",
      border: "none",
      padding: "8px 24px",
      borderRadius: "0",
      cursor: tracking ? "not-allowed" : "pointer",
      fontWeight: "700",
      fontSize: "13px",
      textTransform: "uppercase",
    },
    stopBtn: {
      backgroundColor: !tracking ? "#cccccc" : "#000000",
      color: !tracking ? "#000000" : "#ffffff",
      border: "none",
      padding: "8px 24px",
      borderRadius: "0",
      cursor: !tracking ? "not-allowed" : "pointer",
      fontWeight: "700",
      fontSize: "13px",
      textTransform: "uppercase",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
      gap: "12px",
      marginTop: "8px",
    },
    vehicleCard: (sel, moving) => ({
      padding: "16px",
      border: sel ? "2px solid #FFC107" : "1.5px solid #000000",
      backgroundColor: sel ? "#fffde7" : "#ffffff",
      cursor: "pointer",
      transition: "all 0.15s",
    }),
    vehId: {
      fontWeight: "700",
      fontSize: "13px",
      marginBottom: "4px",
      color: "#000000",
      textTransform: "uppercase",
    },
    vehCoords: {
      fontSize: "12px",
      color: "#555555",
      margin: "4px 0",
    },
    vehStatus: (moving) => ({
      fontSize: "11px",
      fontWeight: "700",
      color: moving ? "#000000" : "#ffffff",
      backgroundColor: moving ? "#FFC107" : "#000000",
      padding: "2px 10px",
      display: "inline-block",
    }),
    detailBox: {
      border: "1.5px solid #000000",
      padding: "20px",
      marginTop: "20px",
      backgroundColor: "#fffde7",
    },
    detailBoxTitle: {
      fontSize: "13px",
      fontWeight: "700",
      color: "#000000",
      marginBottom: "12px",
      textTransform: "uppercase",
    },
    detailGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: "12px",
    },
    detailCard: {
      border: "1.5px solid #000000",
      padding: "12px 16px",
      textAlign: "center",
      backgroundColor: "#ffffff",
    },
    detailVal: {
      fontSize: "16px",
      fontWeight: "700",
      color: "#000000",
    },
    detailLabel: {
      fontSize: "11px",
      color: "#555555",
      marginTop: "4px",
      fontWeight: "700",
    },
    emptyBox: {
      border: "1.5px solid #000000",
      padding: "32px",
      textAlign: "center",
      color: "#888888",
      fontSize: "13px",
      fontWeight: "700",
      backgroundColor: "#f5f5f5",
    },
    errorBox: {
      border: "1.5px solid #000000",
      backgroundColor: "#fffde7",
      padding: "8px 12px",
      fontSize: "12px",
      fontWeight: "700",
      color: "#000000",
      marginBottom: "12px",
    },
  };

  return (
    <div style={s.container}>
      <style>{`@keyframes blink{0%,100%{opacity:1}50%{opacity:0.3}}`}</style>

      {/* Yellow header bar */}
      <div style={s.pageHeader}>
        <h1 style={s.pageHeaderText}>Driver Vehicle Tracking</h1>
      </div>

      <div style={s.contentBody}>

        {/* Controls */}
        <div style={s.sectionTitle}>Tracking Controls</div>
        <hr style={s.sectionDivider} />
        <div style={s.controlRow}>
          <div style={s.pulseWrap}>
            <span style={s.pulse}></span>
            {tracking ? `Live · Updated ${lastUpdated || "..."}` : "Tracking inactive"}
          </div>
          <button style={s.startBtn} disabled={tracking} onClick={() => setTracking(true)}>
            📡 Start Tracking
          </button>
          <button style={s.stopBtn} disabled={!tracking} onClick={() => setTracking(false)}>
            ■ Stop
          </button>
        </div>

        {error && <div style={s.errorBox}>⚠ {error}</div>}

        {/* Vehicle Grid */}
        <div style={s.sectionTitle}>Vehicle Locations</div>
        <hr style={s.sectionDivider} />

        {vehicles.length > 0 ? (
          <>
            <div style={{ fontSize: "12px", color: "#555555", fontWeight: "700", marginBottom: "12px" }}>
              {vehicles.length} vehicle(s) tracked · Click a card to view details
            </div>
            <div style={s.grid}>
              {vehicles.map((v, i) => {
                const moving = Number(v.speed) > 0;
                return (
                  <div
                    key={i}
                    style={s.vehicleCard(selected === i, moving)}
                    onClick={() => setSelected(selected === i ? null : i)}
                  >
                    <div style={s.vehId}>
                      {v.id || v.vehicleNumber || `Vehicle ${i + 1}`}
                    </div>
                    <div style={s.vehCoords}>
                      {(v.lat || v.latitude)?.toFixed(4)}, {(v.lng || v.longitude)?.toFixed(4)}
                    </div>
                    <span style={s.vehStatus(moving)}>
                      {moving ? `Moving · ${v.speed} km/h` : "Stopped"}
                    </span>
                  </div>
                );
              })}
            </div>

            {selectedVehicle && (
              <div style={s.detailBox}>
                <div style={s.detailBoxTitle}>
                  Vehicle {selectedVehicle.id || selectedVehicle.vehicleNumber || `#${selected + 1}`} — Details
                </div>
                <div style={s.detailGrid}>
                  <div style={s.detailCard}>
                    <div style={s.detailVal}>
                      {(selectedVehicle.lat || selectedVehicle.latitude)?.toFixed(5)}
                    </div>
                    <div style={s.detailLabel}>Latitude</div>
                  </div>
                  <div style={s.detailCard}>
                    <div style={s.detailVal}>
                      {(selectedVehicle.lng || selectedVehicle.longitude)?.toFixed(5)}
                    </div>
                    <div style={s.detailLabel}>Longitude</div>
                  </div>
                  <div style={s.detailCard}>
                    <div style={s.detailVal}>{selectedVehicle.speed ?? "0"} km/h</div>
                    <div style={s.detailLabel}>Speed</div>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <div style={s.emptyBox}>
            {tracking ? "Fetching vehicle locations..." : "Start tracking to see vehicle locations"}
          </div>
        )}
      </div>
    </div>
  );
};

export default DriverVehicleTracking;